import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import s from './Checkbox.scss';

const Checkbox = ({ variantClasses = [], id, label, innerHTML, selected, inputChange, children, isError = false }) => {
	const inputChangeHandler = (e) => {
		const $checkbox = e.currentTarget;
		inputChange($checkbox.id, $checkbox.checked);
	};

	const labelAttributes = {};
	label = label || children || null;
	const checkboxClasses = [s.checkbox];
	if (isError === true) checkboxClasses.push(s.checkbox__error);
	if (innerHTML) labelAttributes.dangerouslySetInnerHTML = { __html: purifier(innerHTML) };

	if (!Array.isArray(variantClasses)) variantClasses = [variantClasses.toString()];
	variantClasses.filter((c) => !!c).forEach((c) => {
		checkboxClasses.push(s[c]);
	});

	return (
		<label key={id} htmlFor={id} className={checkboxClasses.join(' ')}>
			<input className={s.checkbox_input} id={id} type="checkbox" name={id} value="1" checked={!!selected} onChange={inputChangeHandler} />
			<span /><span className={s.checkbox_content} {...labelAttributes}>{ label }</span>
		</label>
	);
};

export default hot(module)(Checkbox);
